import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'
import { parse } from 'valibot'

import { getMonthlyTourReportQueryOptions } from '@/features/monthly-tour-reports/query-options'

import { monthlyTourReportParamsSchema } from '../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports/$monthlyTourReportId'
)({
  parseParams: (params) => parse(monthlyTourReportParamsSchema, params),
  loader: async ({
    params: { tenantKey, monthlyTourReportId },
    context: { queryClient }
  }) => {
    const monthlyTourReport = await queryClient.fetchQuery(
      getMonthlyTourReportQueryOptions({
        tenantKey,
        monthlyTourReportId
      })
    )
    return {
      monthlyTourReport
    }
  },
  meta: ({ loaderData }) => [
    {
      title: `${format(loaderData.monthlyTourReport.operatingYearMonth, 'yyyy/MM')} - ${loaderData.monthlyTourReport.partner.name}`
    }
  ]
})
